export default __webpack_public_path__ + "static/media/WarrenTrussImg.51d5d9c6.png";